import React, { useState } from "react";
import "../../styles/desktop/agendamento.css";
import ListaAgendados from "./Lista-de-Agendamentos/listaAgendados";
import { Agendamento } from "../../API/basic/agendamento/Agendar";
import { iluminacaoConfig } from "../../configs/iluminação";
import { exaustoresConfig } from "../../configs/exaustores";

function TelaTemporizacao() {
  // 1) Flag para saber se há exaustores
  const hasExaustores = Array.isArray(exaustoresConfig) && exaustoresConfig.length > 0;

  // ----------------------- Função de validação -----------------------
  const scheduleIsValid = (group, start, end) => {
    if (!group || !start || !end) return false;
    return true;
  };

  // ----------------------- Estados Luzes -----------------------------
  const [grupoLuz, setGrupoLuz] = useState(iluminacaoConfig[0].descricao);
  const [inicioLuz, setInicioLuz] = useState("");
  const [fimLuz, setFimLuz] = useState("");
  const [onValueLuz, setOnValueLuz] = useState(iluminacaoConfig[0].onCommand);
  const [offValueLuz, setOffValueLuz] = useState(iluminacaoConfig[0].offCommand);

  // ----------------------- Estados Exaustor (inicial só se existir) --------------------------
  const [grupoExaustor, setGrupoExaustor] = useState(
    hasExaustores ? exaustoresConfig[0].descricao : ""
  );
  const [inicioExaustor, setInicioExaustor] = useState("");
  const [fimExaustor, setFimExaustor] = useState("");
  const [onValueExaustor, setOnValueExaustor] = useState(
    hasExaustores ? exaustoresConfig[0].onCommand : ""
  );
  const [offValueExaustor, setOffValueExaustor] = useState(
    hasExaustores ? exaustoresConfig[0].offCommand : ""
  );

  // ----------------------- Controle de recarga -----------------------
  const [refreshFlag, setRefreshFlag] = useState(false);

  // ----------------------- Handlers ---------------------
  const handleLuzSelectChange = (e) => {
    const sel = iluminacaoConfig.find(c => c.descricao === e.target.value);
    if (!sel) return;
    setGrupoLuz(sel.descricao);
    setOnValueLuz(sel.onCommand);
    setOffValueLuz(sel.offCommand);
  };

  const handleExaustorSelectChange = (e) => {
    const sel = exaustoresConfig.find(c => c.descricao === e.target.value);
    if (!sel) return;
    setGrupoExaustor(sel.descricao);
    setOnValueExaustor(sel.onCommand);
    setOffValueExaustor(sel.offCommand);
  };

  // ----------------------- Função principal --------------------------
  const temporizar = async () => {
    const luzOk = scheduleIsValid(grupoLuz, inicioLuz, fimLuz);
    const exaustorOk = hasExaustores && scheduleIsValid(grupoExaustor, inicioExaustor, fimExaustor);

    if (!luzOk && !exaustorOk) {
      alert("Preencha todos os campos obrigatórios.");
      return;
    }

    try {
      if (luzOk) {
        await Agendamento(grupoLuz, inicioLuz, fimLuz, onValueLuz, offValueLuz, "Iluminação");
        setInicioLuz("");
        setFimLuz("");
      }
      if (exaustorOk) {
        await Agendamento(grupoExaustor, inicioExaustor, fimExaustor, onValueExaustor, offValueExaustor, "Exaustor");
        setInicioExaustor("");
        setFimExaustor("");
      }
      setRefreshFlag(f => !f);
      alert("Agendamento(s) salvo(s) com sucesso!");
    } catch (error) {
      console.error(error);
      alert("Erro ao salvar agendamento.");
    }
  };

  // ----------------------- JSX ---------------------------------------
  return (
    <div id="TelaTemporizacao">
      <div id="temporizacao">
        <h1>Agendamentos diários</h1>
        <div id="temporizacaoContent">
          {/* Luzes */}
          <div id="temporizacaoContent1">
            <h2>Luzes</h2>
            <div id="temporizacaoContent1-1">
              Grupo
              <select value={grupoLuz} onChange={handleLuzSelectChange}>
                {iluminacaoConfig.map(c => (
                  <option key={c.id} value={c.descricao}>
                    {c.descricao}
                  </option>
                ))}
              </select>
              <label>Início</label>
              <input type="time" value={inicioLuz} onChange={e => setInicioLuz(e.target.value)} />
              <label>Fim</label>
              <input type="time" value={fimLuz} onChange={e => setFimLuz(e.target.value)} />
            </div>
          </div>

          {/* Exaustor — só renderiza se houver dados */}
          {hasExaustores && (
            <div id="temporizacaoContent2">
              <h2>Exaustor</h2>
              <div id="temporizacaoContent2-1">
                Grupo
                <select value={grupoExaustor} onChange={handleExaustorSelectChange}>
                  {exaustoresConfig.map(e => (
                    <option key={e.id} value={e.descricao}>
                      {e.descricao}
                    </option>
                  ))}
                </select>
                <label>Início</label>
                <input type="time" value={inicioExaustor} onChange={e => setInicioExaustor(e.target.value)} />
                <label>Fim</label>
                <input type="time" value={fimExaustor} onChange={e => setFimExaustor(e.target.value)} />
              </div>
            </div>
          )}
        </div>

        <button id="btnSalvar" onClick={temporizar}>
          Salvar
        </button>
      </div>

      <div id="Lista-agendados">
        <ListaAgendados refreshFlag={refreshFlag} />
      </div>
    </div>
  );
}

export default TelaTemporizacao;